import { stdObject } from "./types/stdObject";

export const colors: stdObject = Object.freeze({
  black: "black",
  blue: "#0600b8",
  green: "#009709",
  grey: "#B8B8B8",
  darkBlue: "#030070",
  darkGrey: "#5e5e5eff",
  darkGrey2: "#949494",
  lightBlue: "#178dc9",
  lightBlue2: "#d8e2ff",
  violet: "#b300ff",
  lightViolet: "#faeeff",
  darkViolet: "#490068",
  lightGreen: "#caffcdff",
  lightGreen2: "#a0e7a4ff",
  darkGreen: "#003303",
  lightGrey: "#EBEBEB",
  lightGrey2: "#c0c0c0ff",
  lightGrey3: "rgb(241, 241, 241)",
  lightOrange: "#FFDB9E",
  lightOrange2: "#ffe8c1",
  lightYellow: "#FCFFC7",
  orange: "#D67B00",
  pink: "#ffd8d8",
  pink2: "#ffb5b5",
  red: "#DE0000",
  darkRed: "#8a0829",
  white: "#fff",
  yellow: "#f2ff00ff",
  // sections
  analitics: "#D67B00",
  purchases: "#8a0829",
  sales: "#0561ac",
  services: "#009709",
  admin: "#6a0888",
  items: "#2300A6",
  web: "#00969b",
  settings: "#566573",
  cream: "#CC933B",
  graphColors: [
    "rgb(255, 0, 0)", // Rojo
    "rgb(0, 255, 0)", // Verde
    "rgb(0, 0, 255)", // Azul
    "rgb(255, 255, 0)", // Amarillo
    "rgb(255, 0, 255)", // Magenta
    "rgb(0, 255, 255)", // Cian
    "rgb(255, 128, 0)", // Naranja
    "rgb(128, 0, 255)", // Púrpura
    "rgb(0, 128, 255)", // Azul cielo
    "rgb(0, 200, 100)", // Verde esmeralda
    "rgb(255, 64, 128)", // Rosa fuerte
    "rgb(128, 64, 0)", // Marrón
    "rgb(64, 255, 128)", // Verde menta
    "rgb(255, 64, 64)", // Coral
    "rgb(64, 64, 255)", // Azul intenso
    "rgb(192, 255, 0)", // Lima
    "rgb(255, 192, 203)", // Rosa claro
    "rgb(0, 0, 0)", // Negro
    "rgb(128, 128, 128)", // Gris
    "rgb(255, 255, 255)", // Blanco
  ],
});
